import "./DoubleCheckBadge.css";

export default function DoubleCheckBadge({ qualification }) {
    const review = qualification?.second_review;
    if (review?.completed !== true) return null;

    const reviewedAt = review.reviewed_at ? new Date(review.reviewed_at) : null;
    const details = [
        "Two AI assessments completed. This does not itself mean the frame qualified.",
        review.model ? `Second reviewer: ${review.model}` : null,
        reviewedAt && !Number.isNaN(reviewedAt.getTime()) ? `Reviewed: ${reviewedAt.toLocaleString()}` : null,
    ].filter(Boolean).join(" ");

    return (
        <span className="ai-double-check-badge" tabIndex={0} aria-label={`Double-checked. ${details}`}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="m3 12 4 4L17 6M12 16l3 3 7-9" />
            </svg>
            Double-checked
            <span className="ai-double-check-tooltip" role="tooltip">{details}</span>
        </span>
    );
}
